import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { InsightsService } from '../../services/insights/insights.service';
import * as Highcharts from 'highcharts/highcharts';
import { Options } from 'highcharts';
import { AlertBannerService, AlertType } from '../../lib/alert-banner';
import { ColumnChartService } from '../../services/column-chart/column-chart.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-pulse-nps-count',
  templateUrl: './pulse-nps-count.component.pug',
  styleUrls: ['./pulse-nps-count.component.scss'],
  standalone: false
})
export class PulseNpsCountComponent
  implements OnChanges, AfterViewInit
{
  @Input() start!: any;
  @Input() end!: any;
  @Input() survey!: any;
  @Input() department_category!: any;
  @Input() department!: any;
  @Input() request = '';
  @Input() pause_load = false;
  @Output() dataLoaded = new EventEmitter<void>();
  pulseInsightsActive: any;

  Highcharts: typeof Highcharts = Highcharts;
  detractorChartOptions: Options = {
    series: [
      {
        type: 'column',
        data: [],
      },
      {
        type: 'column',
        data: [],
      },
    ],
  };

  passiveChartOptions: Options = {
    series: [
      {
        type: 'column',
        data: [],
      },
      {
        type: 'column',
        data: [],
      },
    ],
  };

  promoterChartOptions: Options = {
    series: [
      {
        type: 'column',
        data: [],
      },
      {
        type: 'column',
        data: [],
      },
    ],
  };

  constructor(
    private insightsService: InsightsService,
    private alertList: AlertBannerService
  ) {}

  private loadAndSetData() {
    if (this.pause_load) {
      this.emitDataLoaded();
      return;
    }
    this.insightsService
      .getPulseNpsScoreCount(
        this.start,
        this.end,
        this.survey,
        this.department,
        this.request
      )
      .subscribe(
        (data) => {
          this.setChartOptions(data['score_breakdown']);
          this.emitDataLoaded();
        },
        (error) => {
          this.setChartOptions([
            { rate: 1, count: 1 },
            { rate: 2, count: 1 },
            {
              rate: 3,
              count: 1,
            },
            { rate: 6, count: 3 },
            { rate: 7, count: 2 },
            { rate: 8, count: 2 },
            {
              rate: 9,
              count: 3,
            },
            { rate: 10, count: 3 },
          ]);
          console.log(error);
          this.alertList.append([
            {
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true,
            },
          ]);
          this.emitDataLoaded();
        }
      );
  }

  private setChartOptions(data) {
    let detractorCategories = [0, 1, 2, 3, 4, 5, 6];

    let detractorValues = [
      { y: 0, color: '#AF0001' },
      { y: 0, color: '#AF0001' },
      { y: 0, color: '#AF0001' },
      { y: 0, color: '#AF0001' },
      { y: 0, color: '#AF0001' },
      { y: 0, color: '#AF0001' },
      { y: 0, color: '#AF0001' },
    ];
    let passiveCategories = [7, 8];
    let passiveValues = [
      { y: 0, color: '#DE8C02' },
      { y: 0, color: '#DE8C02' },
    ];
    let promoterCategories = [9, 10];
    let promoterValues = [
      { y: 0, color: '#32735F' },
      { y: 0, color: '#32735F' },
    ];

    for (let d of data) {
      if (d['rate'] < 7) {
      detractorValues[d['rate']] = { y: d['count'], color: '#AF0001' };
      }
      else if (d['rate'] < 9) {
        passiveValues[d['rate'] - 7] = { y: d['count'], color: '#DE8C02' };
      }
      else {
        promoterValues[d['rate'] - 9] = { y: d['count'], color: '#32735F' };
      }
    }

    let maxValue =
      _.sumBy(detractorValues, (value) => {
        return value.y;
      }) +
      _.sumBy(passiveValues, (value) => {
        return value.y;
      }) +
      _.sumBy(promoterValues, (value) => {
        return value.y;
      });
    let detractorNData: any = [];
    for (let d of detractorValues) {
      detractorNData.push(maxValue - d['y']);
    }

    let passiveNData: any = [];
    for (let d of passiveValues) {
      passiveNData.push(maxValue - d['y']);
    }

    let promoterNData: any = [];
    for (let d of promoterValues) {
      promoterNData.push(maxValue - d['y']);
    }

    this.detractorChartOptions = ColumnChartService.getOptions(
      $localize`Detractors`,
      detractorCategories,
      detractorValues,
      detractorNData,
      0,
      maxValue,
      'rgb(250,242,242)',
      225
    );
    this.passiveChartOptions = ColumnChartService.getOptions(
      $localize`Passives`,
      passiveCategories,
      passiveValues,
      passiveNData,
      0,
      maxValue,
      'rgb(253,249,242)',
      225
    );
    this.promoterChartOptions = ColumnChartService.getOptions(
      $localize`Promoters`,
      promoterCategories,
      promoterValues,
      promoterNData,
      0,
      maxValue,
      'rgb(244,248,247)',
      225
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }

  ngAfterViewInit(): void {
    if (this.pause_load) {
      this.setChartOptions([]);
    }
  }

  private emitDataLoaded(): void {
    this.dataLoaded.emit();
  }
}
